import { render, staticRenderFns } from "./UpdatePassword.vue?vue&type=template&id=7fc33363"
import script from "../controllers/update-password.js?vue&type=script&lang=js&external"
export * from "../controllers/update-password.js?vue&type=script&lang=js&external"
import style0 from "./UpdatePassword.vue?vue&type=style&index=0&id=7fc33363&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports